import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export interface InfoCard {
  icon: string;
  iconColor?: 'teal' | 'blue' | 'green' | 'default';
  title: string;
  description: string;
  tags?: string[];
  status?: string;
}

@Component({
  selector: 'htx-info-card-grid',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './info-card-grid.component.html',
  styleUrl: './info-card-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoCardGridComponent {
  cards = input.required<InfoCard[]>();
  columns = input<'auto' | 2 | 3 | 4>('auto');
  variant = input<'card' | 'list'>('card');
}
